<template>
    <main id="jeu" :class="['mission-' + mission.id_mission, 'scene-'+ scene.id_scene, scene?.parametres?.class ?? '']">
        <!-- 
            Modal jeu component 
            @TODO : Import ModalJeu to vuejs ?
            <modal-jeu-component />
        -->
  
        <!-- CSRF data for AJAX requests -->
        <form>
            <input type="hidden" :name="csrfTokenName" :value="csrfTokenValue" />
        </form>
  
        <div id="blured-decor">
            <!-- Blured decor -->
            <img
                v-if="decor.image"
                id="blured-decor-image"
                :src="'images/scenes/' + decor.image"
                alt="Decor Image"
                class="decor"
            />
        </div>
  
        <!-- The scene's decor and elements -->
        <div id="decor-elements">
            <!-- Codex component -->
            <list-codexComponent :list_codex="list_codex"></list-codexComponent>
    
            <!-- Decor -->
            <img
                v-if="decor.image"
                id="decor"
                :src="'images/scenes/' + decor.image"
                class="decor"
            />
    
            <div id="list-elements">
                <!-- Elements view -->
                <list-elements-component
                    :list_elements="list_elements">
                </list-elements-component>
            </div>
    
            <!-- Navigation component -->
            <navigation-component
                :utilisateur="utilisateur"
                :joueur_position="joueur_position"
                :mission="mission"
                :list_codex="list_codex"
                :csrfTokenName="csrfTokenName"
                :csrfTokenValue="csrfTokenValue"
            ></navigation-component>
    
            <!-- Dialogue component -->
            <dialogue-component
                :dialogue="dialogue"
                :list_reponses="list_reponses"
                :personnage="personnage"
                :joueur_list_scores="joueur_list_scores"
                :mission="mission"
                :csrfTokenName="csrfTokenName"
                :csrfTokenValue="csrfTokenValue"
            ></dialogue-component>
        </div>
  
        <div class="container position-relative h-100">
            <!-- 
                Mecanique view component 
                @TODO : Import Mecanique view component to vuejs ?
                <mecanique-component/>
            -->
        </div>
    </main>
</template>
  
<script>
    /* global $ */
    import ListCodexComponent from './ListCodexComponent.vue';
    import ListElementsComponent from './ListElementsComponent.vue';
    import NavigationComponent from './NavigationComponent.vue';
    import DialogueComponent from './DialogueComponent.vue';

    export default {
        name: 'JeuComponent',
        components: {
            ListCodexComponent,
            ListElementsComponent,
            NavigationComponent,
            DialogueComponent,
        },
        data(){
            return {
                utilisateur: {},
                mission: {},
                scene: {},
                decor: {},
                dialogue: {},
                list_codex: [],
                personnage: {},
                list_reponses: [],
                titre: 'Serious Game',
                list_elements: [],
                mecanique: {},
                statut: {},
                joueur_position: {},
                joueur_list_scores: [],
                count_objectifs_non_vu: 0,
                count_codex_non_vu: 0,
                max_score_mission: 0,
                icone_codex_tableau_bord: '',
                csrfTokenName: window.csrf_name,
                csrfTokenValue: window.csrf_value,
            }
        },
        methods: {
            checkSceneAnimation( scene ) {
                if ( scene?.parametres?.animation?.fonction?.length ) {
                    // Exécute l'animation de la scène si elle existe
                    window[ scene.parametres.animation.fonction ]();
                }
            },
            // Met à jour les données du jeu
            update_game_data(newData) {
              Object.assign(this.$data, newData);
            },
        },
        mounted() {
            // Lance l'animation d'une scène si elle existe
            this.checkSceneAnimation( this.scene );

            // Rendre disponible la méthode de mise à jour en dehors de Vue.js
            window.update_game_data = this.update_game_data;
            
            // Rendre disponible les datas pour les views CodeIgniter
            window.data = this.$data;
        },
        watch: {
            decor( new_decor, old_decor ) {
                // Animation en fondu du décor (et blured-decor)
                if ( new_decor && (new_decor.id_decor != old_decor.id_decor) ) {
                    // Pour chaque décor, on le clone et créé un effet de fondu
                    $('.decor').each( function() {
                        // Create new ID
                        var current_id = $(this).attr('id');
                        var new_id = "old-" + current_id;
                        // Clone the decor (and blured decor) and change id
                        var cloned_decor = $(this)
                            .clone()
                            .attr('id', new_id)
                        // Add decor after original
                        $(this).after( cloned_decor );

                        // Fade out to show new decor then remove clone
                        $(cloned_decor).fadeOut( 600, 'linear', function() {
                            // remove clone after fadeOut
                            $(this).remove();
                        });
                    })
                }
            },
            scene( newScene ) {
                this.checkSceneAnimation( newScene );
            },
        },
        beforeRouteEnter( to, from, next ) {
            fetch('/api/jeu', {
                method: 'GET',
                headers: {
                'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then(response => {
                if (response.ok) {
                    return response.json(); // Parse the response as JSON
                } else {
                    throw new Error('Failed to fetch data');
                }
            })
            .then(data => {
                // Pass the data to the component via `next`
                next( component => {
                    Object.assign( component.$data, data ); // Set the data on the component
                });
            })
            .catch(error => {
                console.error('Error during route validation:', error);
                next(false); // Prevent navigation
            });
        },
    };
</script>